.root {
  cursor: pointer;
  padding: 12px;
  border-bottom: 1px solid var(--bc-color-border);

  &:last-child {
    border-bottom: none;
  }

  &:nth-child(even) {
    background: var(--bc-color-fill-secondary);
  }
}

.header {
  // icon (20px) + padding 2px * 2
  min-height: 24px;
}

.author {
  font-size: 12px;
  font-weight: 500;
  line-height: 12px;
}

.date {
  display: flex;
  color: var(--bc-color-text-secondary);
  font-size: 12px;
  line-height: 12px;
}

.buttons {
  display: none;
  gap: 4px;
}

.root.editable:hover {
  .date {
    display: none;
  }

  .buttons {
    display: flex;
  }
}

.body {
  font-size: 12px;
  line-height: 18px;
}

.text {
  white-space: pre-wrap;
  word-break: break-word;
}
